module.exports = __webpack_public_path__ + "img/tree_right_layout_icon.fd59902f.svg";